<template>
  <div class="notifications-list-body">
    <loader :isShow="isLoading" :textInfo="''" />
    <div class="prelist">
      <div class="title">Notifications</div>
      <div class="notifications-list-buttons-container">
        <button
          @click="createNotification"
          class="notifications-list-create-new-button"
        >
          New Notification
        </button>
      </div>
    </div>

    <div class="notifications-list-wrapper">
      <List @loading="isLoading = $event" />
    </div>
  </div>
</template>
<script>
import List from '@/components/tasks/ListNotifications'
import Loader from '@/components/Loader.vue'

export default {
  name: 'NotificationsListScreen',
  components: {
    List,
    Loader
  },
  data() {
    return {
      isLoading: false
    }
  },
  activated() {
    this.isLoading = false
  },
  methods: {
    createNotification() {
      this.isLoading = true
      this.$router.push({ name: 'NewNotificationScreen' })
    }
  }
}
</script>
<style scoped>
.notifications-list-body {
  background-color: #f5f6f8;
  padding: 24px;
  overflow: hidden;
}
.notifications-list-wrapper {
  height: 75%;
  overflow: hidden;
  background-color: white;
}

@media (max-width: 768px) {
  .notifications-list-wrapper {
    height: 75%;
    overflow: visible;
    background-color: white;
  }
}

.prelist {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 17px;
}
.title {
  text-align: left;
  letter-spacing: 1px;
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  line-height: 40px;
}

.notifications-list-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.notifications-list-create-new-button {
  text-decoration: none;
  width: 200px;
  height: 42px;
  line-height: 32px;
  color: white;
  background: #66b015;
  border-radius: 4px;
  padding: 2px;
  border: none;

  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: center;
}

.notifications-list-create-new-button:hover {
  cursor: pointer;
}

@media (max-width: 768px) {
  .title {
    width: 100%;
    height: auto;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
  }
  .notifications-list-create-new-button {
    width: 90vw;
    height: 44px;
    font-size: 16px;
    margin-left: 0;
  }
  .prelist {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
  }
}
@media (max-width: 480px) {
  .title {
    font-size: 18px;
    line-height: 24px;
  }
  .notifications-list-create-new-button {
    height: 40px;
    font-size: 16px;
  }
  .notifications-list-body {
    padding: 12px;
  }
}
</style>
